import React from "react";
import PublishDiscussionModal from "./PublishDiscussionModal";

export const QuestionActions = ({
  questionIndex,
  openPublishModalIndex,
  setOpenPublishModalIndex,
  handlePublishDiscussion,
  onDeleteQuestion,
  onDeletePassage, // New prop for passage deletion
  question,
  isPassage = false, // Flag to indicate if this is for a passage
}) => {
  return (
    <div className="flex items-center justify-center space-x-2">
      {/* Publish as discussion button - only for questions */}
      {!isPassage && (
        <button
          type="button"
          onClick={() => setOpenPublishModalIndex(questionIndex)}
          className="text-green-600 hover:text-green-800"
          aria-label="Publish as discussion"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
            />
          </svg>
        </button>
      )}

      {/* Delete button - different handler for passages vs questions */}
      <button
        type="button"
        onClick={() => isPassage ? onDeletePassage() : onDeleteQuestion(questionIndex)}
        className="text-red-600 hover:text-red-800"
        aria-label={isPassage ? "Delete passage" : "Delete question"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
          />
        </svg>
      </button>

      {!isPassage && (
        <PublishDiscussionModal
          isOpen={openPublishModalIndex === questionIndex}
          onClose={() => setOpenPublishModalIndex(null)}
          onSubmit={handlePublishDiscussion}
          title={question?.question}
        />
      )}
    </div>
  );
};